/**
 * useOffPageBrief — detail query for `GET /v1/off-page-briefs/:id`.
 *
 * Returns the row + variants (each with `autopostable` computed by the API).
 */
import { useQuery } from '@tanstack/react-query';
import type { OffPageBriefDetail } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useOffPageBrief(id: string | undefined) {
  return useQuery({
    queryKey: ['off-page-briefs', 'detail', id],
    queryFn: () => apiGet<OffPageBriefDetail>(`/v1/off-page-briefs/${id}`),
    enabled: !!id,
  });
}
